/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SaleReportPage = lazyLoad(
  () => import('./index'),
  module => module.SaleReportPage
);
